import ParsedReceiptResult from './ParsedReceiptResult';

interface ParsedLineItem {
  name: string;
  quantity: string;
  unitPrice: string;
  totalPrice: string;
  lineRaw: string;
}

interface ParsedGlobalIdentifier {
  key: string;
  value: string;
}

interface ParsedItems {
  lineItems: ParsedLineItem[];
  globalIdentifiers: ParsedGlobalIdentifier[];
}

export interface ParsedReceipt {
  status: string;
  parsedItems: ParsedItems;
  error: string[];
}

export interface ParsedReceiptWrapper {
  parsedResult: ParsedReceipt;
  sampleReceiptId: string;
  sampleReceiptTitle: string;
}

interface IProps {
  result: ParsedReceiptWrapper;
}

const ParsedReceiptSummary: React.FC<IProps> = ({ result }) => {
  return (
    <div className="p-4 max-w-xl">
      <div className="flex rounded-lg h-full bg-gray-100 p-8 flex-col">
        <div className="flex items-center mb-3">
          <span className="font-bold">{result.sampleReceiptTitle}</span>
        </div>
        <ParsedReceiptResult result={result.parsedResult} />
      </div>
    </div>
  );
};

export default ParsedReceiptSummary;
